"use strict";
/**
 * @author Maxim Seredkin
 */

import angular from "angular";
import AreaRestService from "./service/area";
import AuditRestService from "./service/audit";
import CountryRestService from "./service/country";
import DaDataRestService from "./service/daData";
import IndustryRestService from "./service/industry";
import InvestorCountryRestService from "./service/investorCountry";
import LandRestService from "./service/land";
import LandCategoryRestService from "./service/landCategory";
import MaintenanceKindRestService from "./service/maintenanceKind";
import MetricRestService from "./service/metric";
import MilestoneRestService from "./service/milestone";
import MunicipalityRestService from "./service/municipality";
import NumericOperatorRestService from "./service/numericOperator";
import OkvedRestService from "./service/okved";
import OperatorRestService from "./service/operator";
import OrgRestService from "./service/org";
import OwnershipFormRestService from "./service/ownershipForm";
import PhaseRestService from "./service/phase";
import ProjectRestService from "./service/project";
import PStatusRestService from "./service/pstatus";
import QuarterRestService from "./service/quarter";
import ReportsRestService from "./service/reports";
import RoleRestService from "./service/role";
import SecurityRestService from "./service/security";
import SettingsRestService from "./service/settings";
import SrcCategoryRestService from "./service/srcCategory";
import StaffRestService from "./service/staff";
import StatusRestService from "./service/status";
import SupportStageRestService from "./service/supportStage";
import SupportToolRestService from "./service/supportTool";
import TaxRestService from "./service/tax";
import UnitRestService from "./service/unit";
import UserRestService from "./service/user";
import HazardClasses from "./service/hazardClasses";
import SupportService from "./service/support";
import SupportTypeService from "./service/supporttype";
import OperationTypeService from "./service/operationtype";
import InvestActivityService from "./service/investActivity";
import SignRestService from './service/sign';
import InvestPlanService from './service/investPlan';

export default angular
  .module("investmentProject.restServices", [])
  .factory("CountryRestService", CountryRestService)
  .factory("IndustryRestService", IndustryRestService)
  .factory("InvestorCountryRestService", InvestorCountryRestService)
  .factory("LandCategoryRestService", LandCategoryRestService)
  .factory("MaintenanceKindRestService", MaintenanceKindRestService)
  .factory("MunicipalityRestService", MunicipalityRestService)
  .factory("OkvedRestService", OkvedRestService)
  .factory("PStatusRestService", PStatusRestService)
  .factory("SrcCategoryRestService", SrcCategoryRestService)
  .factory("SupportToolRestService", SupportToolRestService)
  .factory("ProjectRestService", ProjectRestService)
  .factory("OrgRestService", OrgRestService)
  .factory("StaffRestService", StaffRestService)
  .factory("SecurityRestService", SecurityRestService)
  .factory("LandRestService", LandRestService)
  .factory("NumericOperatorRestService", NumericOperatorRestService)
  .factory("OperatorRestService", OperatorRestService)
  .factory("StatusRestService", StatusRestService)
  .factory("QuarterRestService", QuarterRestService)
  .factory("UserRestService", UserRestService)
  .factory("RoleRestService", RoleRestService)
  .factory("MilestoneRestService", MilestoneRestService)
  .factory("PhaseRestService", PhaseRestService)
  .factory("AuditRestService", AuditRestService)
  .factory("AreaRestService", AreaRestService)
  .factory("UnitRestService", UnitRestService)
  .factory("SupportStageRestService", SupportStageRestService)
  .factory("TaxRestService", TaxRestService)
  .factory("OwnershipFormRestService", OwnershipFormRestService)
  .factory("ReportsRestService", ReportsRestService)
  .factory("SettingsRestService", SettingsRestService)
  .factory("DaDataRestService", DaDataRestService)
  .factory("MetricRestService", MetricRestService)
  .factory("HazardClassesRestService", HazardClasses)
  .factory("SupportRestService", SupportService)
  .factory("SupportTypeRestService", SupportTypeService)
  .factory("OperationTypeRestService", OperationTypeService)
  .factory("InvestActivityRestService", InvestActivityService)
  .factory('SignRestService', SignRestService)
  .factory('InvestPlanRestService', InvestPlanService)
  .name;
